// extracted by mini-css-extract-plugin
module.exports = {"container":"Blocks_container__jX_fq"};